import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { useMe } from '../api/hooks';
import { ErrorPanel, Loading } from '../components/ErrorPanel';
import { Icon } from '../components/Icon';
import { useAppConfig } from '../configContext';
import { prefs, readPref } from '../storage';
import { strings } from '../strings';
import { tenantDisplayName } from '../tenants';

/** Start page: go straight to the only (or remembered) pilot, otherwise let the person choose. */
export function ChoosePilot() {
  const me = useMe();
  const { supportContact } = useAppConfig();
  const [params] = useSearchParams();
  const forceChoice = params.has('choose');

  if (me.isPending) return <Loading />;
  if (me.isError) return <ErrorPanel error={me.error} onRetry={() => void me.refetch()} />;

  const tenants = me.data.tenants;
  if (tenants.length === 0) {
    return (
      <div role="alert" className="card flex gap-3">
        <Icon name="information" className="h-6 w-6 text-brand-magenta" />
        <p className="m-0">{strings.home.noPilots(supportContact)}</p>
      </div>
    );
  }
  const remembered = readPref(prefs.tenant);
  if (!forceChoice) {
    if (tenants.length === 1) return <Navigate to={`/t/${encodeURIComponent(tenants[0].tenantName)}`} replace />;
    if (remembered && tenants.some((t) => t.tenantName === remembered)) {
      return <Navigate to={`/t/${encodeURIComponent(remembered)}`} replace />;
    }
  }

  return (
    <section aria-labelledby="choose-title">
      <h1 id="choose-title" className="mt-0">
        {strings.home.choosePilot}
      </h1>
      <p>{strings.home.choosePilotIntro}</p>
      <ul className="m-0 grid list-none gap-4 p-0 sm:grid-cols-2">
        {tenants.map((t) => (
          <li key={t.tenantName}>
            <Link
              to={`/t/${encodeURIComponent(t.tenantName)}`}
              className="card flex h-full items-center gap-3 text-brand-prussian no-underline hover:border-brand-orchid"
            >
              <Icon name="folder" className="h-8 w-8 text-brand-magenta" />
              <span>
                <span className="block font-bold">{tenantDisplayName(t)}</span>
                {t.tenantName === remembered && <span className="text-small text-neutral-muted">{strings.home.lastViewed}</span>}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
